<template>

  <div class="wrap" v-if="sys">
    <div class="page-header">
      <Nav :activeId="1" />
    </div>

    <!-- 头图 -->
    <div class="section-one">
      <img
        :src="sys.banner"
        :srcset="sys.banner2x + ' 2x'"
        :alt="sys.name + ' 头图'"
      />
      <!-- 头图上方压深，保证白色面包屑在浅色头图上依然可读 -->
      <div class="bp-scrim"></div>

      <div class="nav-bar">
        <div class="nav-bar_label">PRODUCTS AND TECHNOLOGY</div>
        <div class="nav-bar_bread">
          <a href="/home">首页</a><span>产品与技术</span><span>建筑管路系统综合解决方案</span>{{ sys.name }}
        </div>
      </div>
    </div>

    <!-- 同栏目内的系统切换 -->
    <nav class="bp-switch" aria-label="建筑管路系统二级导航">
      <div class="bp-switch__inner">
        <router-link
          v-for="s in systems"
          :key="s.slug"
          :to="s.path"
          class="bp-switch__item"
          :class="{ on: s.slug === sys.slug }"
        >{{ s.short }}</router-link>
      </div>
    </nav>

    <!-- 电脑端：与给水系统页共用 ProductCard 组件 -->
    <ProductCard v-if="!isMobile" :products="products" @open3d="open3d" />

    <!-- 移动端：场景图 + 合成图两栏 -->
    <div id="product-cards" v-else>
      <div class="section-middle product-card">
        <div class="item">
          <img :src="sys.pic" :alt="sys.name + ' 应用场景'" class="zoomable" @click="open3d()" />
        </div>
        <div class="item download">
          <img :src="sys.mobile" :alt="sys.name + ' 产品卖点'" class="zoomable" loading="lazy" @click="open3d()" />
          <a v-if="sys.pdf" :href="sys.pdf" class="link" target="_blank" rel="noopener">
            <img src="../../img/product/btn-down.png" alt="下载产品样册" />
          </a>
        </div>
      </div>
    </div>

    <!-- 3D 构建图入口 -->
    <div class="bp-cta">
      <button class="bp-cta__btn" @click="open3d()">
        <span class="bp-cta__ico">3D</span>
        查看{{ sys.model3dTitle }}构建图
      </button>
      <p class="bp-cta__hint">点击页面上的任意产品图片，同样可以打开 3D 构建图</p>
    </div>

    <Model3D
      v-model="show3d"
      :model-key="sys.model"
      :title="sys.model3dTitle"
      :subtitle="sys.name"
    />

    <Footer />
  </div>

</template>

<script>
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
import ProductCard from '../components/ProductCard-v1.vue'
import { BUILDING_SYSTEMS, findSystem } from '../../data/building-pipe'
import { isMobileUA } from '../../util/device'

export default {
  components: {
    Nav,
    Footer,
    ProductCard,
    // 异步加载：three.js 只在用户真的打开 3D 构建图时才下载
    Model3D: () => import('../../components/viewer3d/Model3D.vue')
  },
  data () {
    return {
      isMobile: false,
      show3d: false,
      systems: BUILDING_SYSTEMS
    }
  },
  computed: {
    sys () {
      return findSystem(this.$route.params.slug)
    },
    products () {
      const s = this.sys
      return s ? [{
        id: 1,
        name: s.name,
        pic: s.pic,
        pic2x: s.pic2x,
        info: s.info,
        info2x: s.info2x,
        desc: s.desc,
        desc2x: s.desc2x,
        url: s.pdf
      }] : []
    }
  },
  watch: {
    sys: {
      immediate: true,
      handler (s) {
        if (!s) return
        document.title = s.name + '- 班尼戈（中国）'
        const desc = document.querySelector('meta[name="description"]')
        if (desc) {
          desc.setAttribute('content',
            '班尼戈' + s.name + '：建筑管路系统综合解决方案，提供产品资料与 3D 结构构建图。')
        }
      }
    }
  },
  created () {
    // 路由里没有这个 slug 时回到栏目首个系统，避免出现空白页
    if (!this.sys) this.$router.replace(BUILDING_SYSTEMS[0].path)
  },
  mounted () {
    this.isMobile = isMobileUA()
  },
  methods: {
    open3d () {
      this.show3d = true
    }
  }
}
</script>

<style scoped lang="less">
/* 头图顶部压深 */
.bp-scrim {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 34%;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(6, 12, 16, 0.62) 0%, rgba(6, 12, 16, 0.28) 55%, rgba(6, 12, 16, 0) 100%);
}

/* 二级系统切换条 */
.bp-switch {
  background: #f5f7f8;
  border-bottom: 1px solid #e4e9eb;
}
.bp-switch__inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.bp-switch__item {
  display: block;
  padding: 20px 22px;
  font-size: 16px;
  color: #4a5359;
  position: relative;
  transition: color 0.25s;
  &:hover { color: #0c8066; }
  &.on {
    color: #0c8066;
    font-weight: 600;
    &::after {
      content: '';
      position: absolute;
      left: 22px;
      right: 22px;
      bottom: 0;
      height: 3px;
      background: #0c8066;
    }
  }
}

/* 3D 构建图入口 */
.bp-cta {
  background: #0d1418;
  padding: 60px 20px 66px;
  text-align: center;
}
.bp-cta__btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #fff;
  font-size: 17px;
  padding: 15px 34px;
  border-radius: 3px;
  cursor: pointer;
  transition: 0.25s;
  &:hover { background: #0c8066; border-color: #0c8066; }
}
.bp-cta__ico {
  font-size: 12px;
  letter-spacing: 1px;
  border: 1px solid currentColor;
  border-radius: 2px;
  padding: 2px 6px;
}
.bp-cta__hint {
  margin: 18px 0 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.38);
}

@media (max-width: 900px) {
  .bp-switch__item { padding: 14px; font-size: 14px; }
  .bp-cta { padding: 40px 16px; }
}
</style>
